export const defaultRowCount = 25;
// TODO - capitalize this
